<template>
  <div class="offer-search">
    <label>
      <input
        v-model="showAllOffersToggle"
        type="checkbox"
        value="true"
        class="checkbox-input"
        @change="toggleShowAllOffers()"
      >
      <span class="checkbox-label">{{ $modeoL10n.all_offers }}</span>
    </label>

    <div class="offer-search__details">
      <div class="offer-search__labels">
        <p class="availability availability--small availability--inline availability--light">
          {{ statusLabels['offer-draft'] }}
        </p>
        <p class="availability availability--small availability--inline availability--positive">
          {{ statusLabels['offer'] }}
        </p>
      </div>
      <div class="offer-search__count">
        Näytetään {{ foundPosts }} tarjousta
      </div>
    </div>
    <table class="woocommerce-orders-table woocommerce-orders-table--offers">
      <thead>
        <tr>
          <th class="woocommerce-orders-table__header">
            Tila
          </th>
          <th class="woocommerce-orders-table__header">
            Asiakkaan viite
          </th>
          <th class="woocommerce-orders-table__header">
            Tarjousnro
          </th>
          <th class="woocommerce-orders-table__header">
            Asiakas
          </th>
          <th class="woocommerce-orders-table__header">
            Myyjä
          </th>
          <th class="woocommerce-orders-table__header">
            Luotu
          </th>
          <th class="woocommerce-orders-table__header">
            Voimassa
          </th>
          <th class="woocommerce-orders-table__header">
            Hinta
          </th>
          <th class="woocommerce-orders-table__header">
            <span class="screen-reader-text">Toimenpiteet</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="offer in offers"
          :key="offer.id"
          class="woocommerce-orders-table__row woocommerce-orders-table__row--link order"
          :class="['woocommerce-orders-table__row--status-' + offer.status, {'status-has-hover': offerHover}]"
          @click="selectOffer(offer)"
        >
          <td class="woocommerce-orders-table__cell woocommerce-orders-table__cell-order-status">
            <span class="woocommerce-orders-table__cell-order-status-text">{{ statusLabels[offer.status] }}</span>
          </td>
          <td
            class="woocommerce-orders-table__cell woocommerce-orders-table__cell--highlight"
            :class="{'woocommerce-orders-table__cell--inactive' : !offer.customer_reference}"
          >
            {{ offer.customer_reference || 'Ei viitettä' }}
          </td>
          <td class="woocommerce-orders-table__cell woocommerce-orders-table__cell--highlight">
            WC-{{ offer.id }}
          </td>
          <td
            class="woocommerce-orders-table__cell woocommerce-orders-table__cell--highlight"
            :class="{'woocommerce-orders-table__cell--inactive' : !offer.billing_company}"
          >
            <span class="woocommerce-orders-table__mobile">Asiakas: </span>
            {{ offer.billing_company || '-' }}
          </td>
          <td class="woocommerce-orders-table__cell">
            <span class="woocommerce-orders-table__mobile">Myyjä: </span>
            {{ offer.salesperson.first_name || '-' }}
          </td>
          <td class="woocommerce-orders-table__cell woocommerce-orders-table__cell-order-date">
            <span class="woocommerce-orders-table__mobile">Luotu: </span>
            <time :datetime="offer.created_date">{{ offer.created_date | formatDate }}</time>
          </td>
          <td class="woocommerce-orders-table__cell woocommerce-orders-table__cell-order-date">
            <span class="woocommerce-orders-table__mobile">Voimassa: </span>
            <time :datetime="offer.offer_expiry">{{ offer.offer_expiry || '-' }}</time>
          </td>
          <td class="woocommerce-orders-table__cell woocommerce-orders-table__cell-order-total">
            <span class="woocommerce-Price-amount amount">{{ offer.totals.subtotal | formatPrice }}</span>
          </td>
          <td class="woocommerce-orders-table__cell woocommerce-orders-table__cell-actions">
            <offer-actions-menu
              :offer-id="offer.id"
              :nonce="nonce"
              :current-user-can-delete="currentUserIsAdmin || currentUserId == offer.salesperson.id"
              @mouseover.native="offerHover = false"
              @mouseout.native="offerHover = true"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import OfferActionsMenu from './offer-actions-menu.vue';

export default {

    components: {
        OfferActionsMenu,
    },

    props: {
        offers: {
            type: Array,
            default: function () {
                return [];
            },
        },
        cartUrl: {
            type: String,
            default: '',
        },
        nonce: {
            type: String,
            default: '',
        },
        currentUserId: {
            type: Number,
            default: 0,
        },
        currentUserIsAdmin: Boolean,
        foundPosts: {
            type: Number,
            default: 0,
        },
        showAllOffers: Boolean,
    },


    data: function() {
        return {
            statusLabels: {'offer': 'Valmis', 'offer-draft': 'Luonnos'},
            offerHover: true,
            showAllOffersToggle: this.showAllOffers,
        }
    },

    methods: {
        selectOffer: function(offer) {
            let form = document.createElement('form');
            form.method = 'POST';
            form.action = this.cartUrl;

            let input = document.createElement('input');
            input.type = "text";
            input.name = "change_offer";
            input.value = offer.id;
            form.appendChild(input);
            document.body.appendChild(form);
            form.submit();
        },
        toggleShowAllOffers: function( ) {
            let location = window.location.href;
            location = location.split('page')[0];
            location = location.split('?')[0];

            if ( this.showAllOffersToggle ) {
                window.location.href = location + '?user=all';
            } else {
                window.location.href = location;
            }
        },

    },
}

</script>
